import '../App.css';
import Header1 from './Header'
import Container from "react-bootstrap/Container";
import Main from "./main/main";

const App = () => {
    return (
        <Container fluid className="p-3">
            <Header1/>
            <Main />
        </Container>
    );
};
export default App;
